import {CoreMenu} from '@core/types';

export const menu: CoreMenu[] = [
    /*{
        id: 'home',
        title: 'Home',
        translate: 'MENU.HOME',
        type: 'item',
        icon: 'home',
        url: 'home'
    },
    {
        id: 'sample',
        title: 'Sample',
        translate: 'MENU.SAMPLE',
        type: 'item',
        icon: 'file',
        url: 'sample'
    },*/
    {
        id: 'landing',
        title: 'Landing',
        translate: 'MENU.LANDING',
        type: 'item',
        icon: 'home',
        url: 'landing',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'COUNSELLOR', 'UNIVERSITY']
    },
    {
        id: 'admission',
        title: 'Admission',
        translate: 'MENU.ADMISSION',
        type: 'item',
        icon: 'home',
        url: 'admission',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'COUNSELLOR', 'UNIVERSITY']
    },
    {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'MENU.DASHBOARD',
        type: 'item',
        icon: 'home',
        url: 'dashboard',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'COUNSELLOR', 'UNIVERSITY']
    },
    {
        id: 'landing-page',
        title: 'Landing Page',
        translate: 'MENU.LANDING_PAGE',
        type: 'item',
        icon: 'home',
        url: 'university-landing',
        availableTo: ['UNIVERSITY']
    },
    {
        id: 'admins',
        title: 'Admins',
        translate: 'MENU.ADMINS',
        type: 'item',
        icon: 'home',
        url: 'admins',
        availableTo: ['SUPER_ADMIN', 'ADMIN']
    },
    {
        id: 'counsellors',
        title: 'Counsellors',
        translate: 'MENU.COUNSELLORS',
        type: 'item',
        icon: 'home',
        url: 'counsellors',
        availableTo: ['SUPER_ADMIN', 'ADMIN']
    },
    {
        id: 'universities',
        title: 'Universities',
        translate: 'MENU.UNIVERSITIES',
        type: 'item',
        icon: 'home',
        url: 'universities',
        availableTo: ['SUPER_ADMIN', 'ADMIN']
    },
    {
        id: 'programs',
        title: 'Programs',
        translate: 'MENU.PROGRAMS',
        type: 'item',
        icon: 'home',
        url: 'programs',
        availableTo: ['UNIVERSITY'],
    },
    {
        id: 'courses',
        title: 'Courses',
        translate: 'MENU.COURSES',
        type: 'item',
        icon: 'home',
        url: 'courses',
        availableTo: ['UNIVERSITY']
    },
    {
        id: 'branches',
        title: 'Branches',
        translate: 'MENU.BRANCHES',
        type: 'item',
        icon: 'home',
        url: 'branches',
        availableTo: ['UNIVERSITY']
    },
    {
        id: 'pcbmapping',
        title: 'PCB-Mapping',
        translate: 'MENU.PCBMAPPING',
        type: 'item',
        icon: 'home',
        url: 'pcbmapping',
        availableTo: ['UNIVERSITY']
    },
    {
        id: 'stages',
        title: 'Stages',
        translate: 'MENU.STAGES',
        type: 'item',
        icon: 'home',
        url: 'stages',
        availableTo: ['SUPER_ADMIN', 'ADMIN']
    },
    {
        id: 'reasons',
        title: 'Reasons',
        translate: 'MENU.REASONS',
        type: 'item',
        icon: 'home',
        url: 'reasons',
        availableTo: ['SUPER_ADMIN', 'ADMIN']
    },
    {
        id: 'srmapping',
        title: 'SR-Mapping',
        translate: 'MENU.SRMAPPING',
        type: 'item',
        icon: 'home',
        url: 'srmapping',
        availableTo: ['SUPER_ADMIN', 'ADMIN']
    },
    {
        id: 'students',
        title: 'Students',
        translate: 'MENU.STUDENTS',
        type: 'item',
        icon: 'home',
        url: 'students',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'COUNSELLOR', 'UNIVERSITY']
    },
    {
        id: 'universitysettings',
        title: 'Settings',
        translate: 'MENU.UNIVERSITYSETTINGS',
        type: 'item',
        icon: 'home',
        url: 'universitysettings',
        availableTo: ['UNIVERSITY']
    },
    {
        id: 'mails',
        title: 'Mails',
        translate: 'MENU.MAILS',
        type: 'item',
        icon: 'home',
        url: 'mails',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'COUNSELLOR']
    },
    {
        id: 'text_messages',
        title: 'Text Messages',
        translate: 'MENU.TEXT_MESSAGES',
        type: 'item',
        icon: 'home',
        url: 'text-messages',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'COUNSELLOR']
    },
    {
        id: 'whats_apps',
        title: 'Whatsapps',
        translate: 'MENU.WHATSAPP',
        type: 'item',
        icon: 'home',
        url: 'whatsapps',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'COUNSELLOR']
    }
];
